export default "__VITE_ASSET__pjWHDcDz__"